import React from 'react';
const SvgLogout = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 36 36", focusable: false }, props),
    React.createElement("path", { d: "M16 6V2H2v32h14v-4H6V6h10z" }),
    React.createElement("path", { d: "M24.82 8.81L22 11.64 26.36 16H8v4h18.36L22 24.36l2.82 2.83 9.2-9.19-9.2-9.19z" })));
export default SvgLogout;
//# sourceMappingURL=Logout.js.map